export default {
  ducky: 'Ducky',
  home: 'Forside',
  help: 'Hjelp',
  account: 'Konto',
  logout: 'Logg ut',
  language_menu: 'Språk',
  menu: 'Meny',
};
